module.exports = __webpack_public_path__ + "static/imgVacancie4-f73e4ef26cd1177c291a4b3db8a8b001.png";